import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { loadTrackers } from '../utils/tracking';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented (localStorage is a browser global;
    // setShowBanner is a stable setter — no deps needed).
    const consent = localStorage.getItem('valuare-cookie-consent');
    if (!consent) {
      // Show banner after 1 second delay
      setTimeout(() => setShowBanner(true), 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAccept = () => {
    localStorage.setItem('valuare-cookie-consent', 'accepted');
    setShowBanner(false);
    // GDPR: only NOW load Google Analytics, Meta Pixel and PostHog
    loadTrackers();
  };

  const handleDecline = () => {
    localStorage.setItem('valuare-cookie-consent', 'declined');
    setShowBanner(false);
    // Trackers remain unloaded — no tracking without consent
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(21, 38, 60, 0.96)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      color: '#ffffff',
      padding: '20px',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1), 0 -8px 32px rgba(15,28,45,0.3)',
      zIndex: 9999,
      animation: 'slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
      
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
        <div style={{ flex: '1', minWidth: '300px' }}>
          <p style={{ 
            margin: '0 0 8px 0', 
            fontSize: '14px', 
            lineHeight: '1.6',
            color: '#ffffff'
          }}>
            <strong>Política de Cookies e Privacidade</strong>
          </p>
          <p style={{ 
            margin: 0, 
            fontSize: '13px', 
            lineHeight: '1.6',
            color: 'rgba(255,255,255,0.85)'
          }}>
            Utilizamos cookies e tecnologias de rastreamento (Google Analytics, Meta Pixel) para melhorar a sua experiência no site, analisar tráfego e personalizar conteúdo. Ao aceitar, concorda com o processamento dos seus dados conforme a nossa política de privacidade e o RGPD.
          </p>
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <Button
            onClick={handleDecline}
            variant="outline"
            data-testid="cookie-decline-btn"
            style={{
              backgroundColor: 'transparent',
              border: '1px solid rgba(255,255,255,0.25)',
              color: '#ffffff',
              fontSize: '13px',
              padding: '8px 20px',
              borderRadius: '8px'
            }}
          >
            Recusar
          </Button>
          <Button
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
            style={{
              backgroundColor: '#c5a572',
              color: '#ffffff',
              fontSize: '13px',
              padding: '8px 24px',
              border: 'none',
              borderRadius: '8px',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25), 0 4px 12px rgba(197,165,114,0.35)'
            }}
          >
            Aceitar Cookies
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
